// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"547fda61","85":"80c74b5f","142":"57128cde","358":"acbcfafc","548":"9d3b3374","571":"9ea72084","632":"f0f58840","669":"8bb5700f","734":"b1ac9548","744":"8b9332b3","823":"5313d551","836":"1a19e764","868":"fc48033c"}[chunkId] + ".chunk.js";
};